$(function () {
    $("*").on("click", function (e) {
        if (!$(e.target).is("#filterDropdownMenuButton") && $("#filterDropdownMenuButton").attr("aria-expanded") == "true")
            $("#filterDropdownMenuButton").click();
    });

    var searchBtn = $('.searching-container .searching-detail button.searching-btn');
    var chartBtn = $('.searching-container .searching-detail button.chart-btn');

    searchBtn.on('click', function () {
        let $this = $(this);
        if ($this.hasClass('open')) {
            $this.removeClass('open');
            $('.searching-container .searching').stop().slideUp(200);
        } else {
            $this.addClass('open');
            $('.searching-container .searching').stop().slideDown(200);
        }
        chartBtn.removeClass('open');
        $('.searching-container .chart').stop().slideUp(200);
    });

    chartBtn.on('click', function () {
        let $this = $(this);
        if ($this.hasClass('open')) {
            $this.removeClass('open');
            $('.searching-container .chart').stop().slideUp(200);
        } else {
            $this.addClass('open');
            $('.searching-container .chart').stop().slideDown(200);
        }
        searchBtn.removeClass('open');
        $('.searching-container .searching').stop().slideUp(200);
    });
});
